import { Divider, Flex, Icon, Text, Tooltip } from "@chakra-ui/react"
import { Logo } from "component/Logo"
import { SidebarItemsList } from "component/sidebar/SidebarItemsList"
import { UserMenu } from "component/sidebar/UserMenu"
import { useSidebarContext } from "context/sidebarContext"
import { FiChevronsLeft, FiChevronsRight } from "react-icons/fi"

// Ширина в пикселях, а не в процентах: в процентах свёрнутая панель на узком
// экране становилась уже аватарки, и та вылезала за край
const EXPANDED_WIDTH = "256px"
const COLLAPSED_WIDTH = "68px"

export const Sidebar = () => {
  const { isCollapsed, toggleCollapsed } = useSidebarContext()

  const collapseLabel = isCollapsed ? "Развернуть панель" : "Свернуть панель"

  return (
    <Flex
      as="nav"
      h="full"
      w={isCollapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH}
      flexShrink={0}
      direction="column"
      bg="gray.50"
      borderRight="1px solid"
      borderColor="gray.200"
      transition="width 0.2s ease"
    >
      {/* Logo. Блок одной высоты в обоих видах: при сворачивании лого и
          линия под ним остаются на месте. В развёрнутой лого по левому краю
          иконок и подписей разделов (24px) */}
      <Flex
        h="32px"
        mt={6}
        flexShrink={0}
        alignItems="center"
        justifyContent={isCollapsed ? "center" : "flex-start"}
        px={isCollapsed ? 0 : 6}
      >
        {isCollapsed ? (
          <Logo isIconOnly imageSize="32px" />
        ) : (
          <Logo isDark imageSize="128px" />
        )}
      </Flex>

      <Divider mt={5} mb={2} mx={3} w="auto" flexShrink={0} borderColor="gray.200" />

      {/* Sidebar Items Routes */}
      <Flex flex={1} direction="column" overflowY="auto" overflowX="hidden" px={3} py={2}>
        <SidebarItemsList />
      </Flex>

      {/* Collapse Btn — одно место для обоих состояний, чтобы кнопка не прыгала */}
      <Flex flexShrink={0} px={3} pb={2}>
        <Tooltip
          label={collapseLabel}
          placement="right"
          openDelay={300}
          isDisabled={!isCollapsed}
          hasArrow
        >
          <Flex
            as="button"
            type="button"
            aria-label={collapseLabel}
            w="full"
            h={9}
            alignItems="center"
            justifyContent={isCollapsed ? "center" : "flex-start"}
            gap={3}
            px={isCollapsed ? 0 : 3}
            borderRadius="md"
            fontSize="sm"
            fontWeight="medium"
            color="gray.500"
            transition="background 0.15s ease"
            _hover={{ bg: "gray.100", color: "gray.700" }}
            // Серое кольцо фокуса, как у кнопок Chakra, вместо синей рамки браузера
            _focusVisible={{ outline: "none", boxShadow: "outline" }}
            onClick={toggleCollapsed}
          >
            <Icon as={isCollapsed ? FiChevronsRight : FiChevronsLeft} boxSize={4} />
            {!isCollapsed && <Text>Свернуть</Text>}
          </Flex>
        </Tooltip>
      </Flex>

      {/* User */}
      <Flex flexShrink={0} borderTop="1px solid" borderColor="gray.200" p={3}>
        <UserMenu />
      </Flex>
    </Flex>
  )
}
